import React from 'react';
import { Box, Container, Heading, Text, SimpleGrid, VStack, Image } from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);

const WhyUsFounderStory = ({ data }) => {
  return (
    <Box py={{ base: 16, md: 20 }} bg="white">
      <Container maxW="container.xl">
        <SimpleGrid columns={{ base: 1, lg: 2 }} spacing={12} alignItems="center">
          <MotionBox
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <Box
              borderRadius="2xl"
              overflow="hidden"
              boxShadow="0 20px 60px rgba(0,0,0,0.15)"
            >
              <Image
                src={data.image}
                alt="Team collaboration"
                w="full"
                h="400px"
                objectFit="cover"
              />
            </Box>
          </MotionBox>

          <MotionBox
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <VStack align="start" spacing={4}>
              <Heading size="2xl" fontWeight="900" color="brand.800">
                {data.title}
              </Heading>
              <Text fontSize="md" color="brand.600" lineHeight="1.8">
                {data.description1}
              </Text>
              <Text fontSize="md" color="brand.600" lineHeight="1.8">
                {data.description2}
              </Text>
            </VStack>
          </MotionBox>
        </SimpleGrid>
      </Container>
    </Box>
  );
};

export default WhyUsFounderStory;